import { closestCenter, DndContext, DragEndEvent } from '@dnd-kit/core'
import { arrayMove, SortableContext, verticalListSortingStrategy } from '@dnd-kit/sortable'

import { SeqWorkspaceItem } from './components/seq-workspace-item'
import { MilestoneItem } from '../../../../entities/workflow/types/workflow.types'

type SeqWorkspaceProps = {
  estimations: Map<number, number>
  milestones: MilestoneItem[]
  onEstimationChanged?: (milestoneId: number, estimation: number) => void
  onSeqChanged?: (newOrderedMilestones: MilestoneItem[]) => void
}

export const SeqWorkspace = ({ milestones, onSeqChanged, onEstimationChanged, estimations }: SeqWorkspaceProps) => {
  const handleDragEnd = (event: DragEndEvent) => {
    const { active, over } = event

    if (over && active.id !== over.id) {
      const oldIndex = milestones.findIndex((item) => item.id === active.id)
      const newIndex = milestones.findIndex((item) => item.id === over.id)

      const newOrderedMilestones = arrayMove(milestones, oldIndex, newIndex)

      onSeqChanged?.(newOrderedMilestones)
    }
  }

  const handleEstimationChange = (milestoneId: number, estimation: number) => {
    onEstimationChanged?.(milestoneId, estimation)
  }

  return (
    <div style={{ maxWidth: '400px', margin: '0 auto' }}>
      <DndContext
        collisionDetection={closestCenter}
        onDragEnd={handleDragEnd}
      >
        <SortableContext
          items={milestones.map((item: any) => item.id)}
          strategy={verticalListSortingStrategy}
        >
          {milestones.map((milestone: MilestoneItem) => (
            <SeqWorkspaceItem
              key={milestone.id}
              estimation={estimations.get(milestone.id) ?? 1}
              id={milestone.id}
              onEstimationChanged={handleEstimationChange}
              text={milestone.name}
            />
          ))}
        </SortableContext>
      </DndContext>
    </div>
  )
}
